import { render } from "./PostListAction.vue?vue&type=template&id=47274a27"
import script from "./PostListAction.vue?vue&type=script&lang=js"
export * from "./PostListAction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__